/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, {Component} from 'react';
import Select from 'react-select';
import {SEARCH_OPTIONS} from '../../../constants/APP_CONSTANTS';
import PropTypes from "prop-types";

export class CuratedSearch extends Component{

    static get propTypes(){
        return {
            updateSearchParams: PropTypes.func.isRequired
        };
    }

    constructor(props){
        super(props);
        this.state = {
            defaultValue: {
                value: '0',
                label:'Filter Options'
            },
            placeholder: SEARCH_OPTIONS.FILTER,
            searchEnabled: false,
            dropdownOptions: [
                { value:'0', label: 'Filter Options' },
                { value:'1', label: 'ISBN'},
                { value:'2', label: 'Title'},
            ]
        };
        this.onChange = this.onChange.bind(this);
        this.generatePlaceholder = this.generatePlaceholder.bind(this);

    }

    onChange(e){
        this.setState({defaultValue: {value: e.value, label: e.label}});
        this.generatePlaceholder(e.value);
    }

    generatePlaceholder(value){
        let params='';
        if(value === '0'){
            params = {
                placeholder: SEARCH_OPTIONS.FILTER,
                searchEnabled:false
            };
        }
        if(value === '1'){
            params = {
                searchParam: 'isbn',
                placeholder: SEARCH_OPTIONS.ISBN,
                searchEnabled:true,
            };
        }
        if(value === '2'){
            params = {
                searchParam: 'title',
                placeholder: SEARCH_OPTIONS.TITLE,
                searchEnabled:true
            };
        }
        this.props.updateSearchParams(params);
    }

    render(){
        return(
            <div>
                <div className='dropdown'>
                    <Select arrowRenderer={this.props.arrowRenderer || this.arrowDown}
                        backspaceRemoves={false}
                        clearable={false}
                        name={this.state.defaultValue.label}
                        onChange={(e)=> this.onChange(e)}
                        options={this.state.dropdownOptions}
                        searchable={false}
                        value={this.state.defaultValue.value}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/CuratedSearch/CuratedSearchComponent.js